import {
  AppBar,
  Avatar,
  Box, Divider,
  Hidden,
  IconButton,
  Link, ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography
} from "@mui/material";
import {
  Input, Lock, Logout,
  Menu as MenuIcon, Person, PersonAdd,
  Settings as SettingsIcon
} from "@mui/icons-material";
import { makeStyles } from '@mui/styles';
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {signOutRequest, logoutAsync} from "../../../features/authSlice";
import {
  getSessionCompanyName,
  getSessionRooms,
  setSessionCalendarSettings, setSessionCompanyIsRegistrable,
  setSessionCompanyName
} from "../../../helpers/sessionHelper";
import EnhancedIconButton from "../../enhanced/EnhancedIconButton";
import Settings from "../../Settings";
import {fetchCompanyList, signOutRequestLists} from "../../../features/listsSlice";

function Topbar(props) {
  const { onSidebarOpen } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const companyList = useSelector((state) => state.lists.companyList);
  const [headerLabel, setHeaderLabel] = useState(getSessionCompanyName());
  const [isShowSettings, setShowSettings] = useState(true);

  const onSignOut = () => {
    dispatch(signOutRequest(history));
    dispatch(signOutRequestLists());
    dispatch(logoutAsync());
  };

  const [openSettings, setOpenSettings] = useState(false);
  useEffect(() => {
    if (companyList.length === 0) {
      dispatch(fetchCompanyList());
    }

    if (
      companyList.length === 1
      && companyList.at(0).roomList.length === 1
      && Object.keys(getSessionRooms()).length === 0
      && companyList.at(0).roomList.length === 1
    ) {
      var roomId = companyList.at(0).roomList.at(0).id;
      var companyId = companyList.at(0).id;
      setShowSettings(false);
      setSessionCompanyName(companyList.at(0).name);
      setSessionCompanyIsRegistrable(companyList.at(0).isRegistrable);
      setSessionCalendarSettings(JSON.parse('{"companyId": ' + companyId + ', "' + roomId + '": true}'));
      setHeaderLabel(getSessionCompanyName());
    } else if (
      (
        companyList.length > 1
        && Object.keys(getSessionRooms()).length === 0
      ) ||
      (
        companyList.length === 1
        && Object.keys(getSessionRooms()).length === 0
        && companyList.at(0).roomList.length !== 1
      )
    ) {
      setOpenSettings(true);
    }
  }, [companyList, headerLabel]);


  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <AppBar className={classes.root}>
      <Toolbar>
        <RouterLink to="/" className={classes.title}>
          <Typography variant="h3" component="h1" className={classes.title} sx={titleStyle.title}>
            {headerLabel}
          </Typography>
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden lgUp>
          <EnhancedIconButton ariaLabel="menu" tooltip="Menu" color="inherit" Icon={MenuIcon} onClick={onSidebarOpen} />
        </Hidden>
        {
          isShowSettings ? (
            <EnhancedIconButton
              ariaLabel="settings"
              tooltip="Nastavení"
              color="inherit"
              Icon={SettingsIcon}
              onClick={() => setOpenSettings(true)}
            />
          ) : null
        }
        <Box>
          <Tooltip title="Můj profil">
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Avatar></Avatar>
            </IconButton>
          </Tooltip>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={() => history.push("/profile")}>
            <Avatar /> Můj profil
          </MenuItem>
          <MenuItem onClick={() => history.push("/change-password")}>
            <ListItemIcon>
              <Lock fontSize="small" />
            </ListItemIcon>
            Změnit heslo
          </MenuItem>
          <Divider />
          <MenuItem onClick={onSignOut}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Odhlásit se
          </MenuItem>
        </Menu>
      </Toolbar>
      <Settings
        openSettings={openSettings}
        setOpenSettings={setOpenSettings}
        companyList={companyList}
        setHeaderLabel={setHeaderLabel}
      />
    </AppBar>
  );
}

const titleStyle = {
  title: {
    color: "white",
    textDecoration: "none"
  }
}

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none"
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  }
}));


export default Topbar;
